<template>
  <button
    type="button"
    @click="goBack"
    class="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-sm text-gray-700 shadow-sm"
    :aria-label="ariaLabel"
  >
    <svg class="h-4 w-4 mr-2 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M12.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L8.414 10l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"/>
    </svg>
    <span>{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    label: { type: String, default: 'Back' },
    fallback: { type: String, default: '/admin/choose' },
    ariaLabel: { type: String, default: 'Go back to previous screen' }
  },
  methods: {
    goBack() {
      try {
        // Prefer router back if there is history; otherwise, fallback
        if (window && window.history && window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.push(this.fallback)
        }
      } catch (e) {
        this.$router.push(this.fallback)
      }
    }
  }
}
</script>

<style scoped>
</style>

